import { TranslatePipe } from '@ngx-translate/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Transition } from '@uirouter/angular';

import {
    Training,
    TrainingService,
    TrainingPriceService,
    TrainingUniverse,
    Universe,
} from '../../../../_services';
import { JhiLanguageHelper } from '../../../../shared';
import { TrainingComponent } from '../../training.component';
import { CommaDotPipe } from '../../../_shared/comma-dot.pipe';
import {
    IMultiSelectOption,
    IMultiSelectTexts,
} from 'angular-2-dropdown-multiselect';
import { TrainingPrice } from '../location/price.component';

@Component({
    selector: 'training-detail-description',
    templateUrl: 'description.component.html',
    styleUrls: ['description.component.scss'],
    providers: [TranslatePipe, CommaDotPipe],
})
export class TrainingDetailDescriptionComponent implements OnInit {
    trainingId: any;
    training: Training;
    @Input() trainingPicturePath = '';
    @Output() getTraining: EventEmitter<any> = new EventEmitter<Training>();
    @Output() trainingSaved = new EventEmitter<Training>();
    universes: Universe[];
    partners: any;
    success = false;
    language: string;
    pictureFileError = '';
    time = '';

    optionsModel: number[];
    myOptions: IMultiSelectOption[];

    myTexts: IMultiSelectTexts = {
        checkAll: 'Tout sélectionner',
        uncheckAll: 'Tout desélectionner',
        checked: 'Selectionné',
        checkedPlural: 'Selectionnées',
        searchPlaceholder: 'Rechercher...',
        defaultTitle: 'Selectionner',
    };

    constructor(
        private trainingService: TrainingService,
        private trainingPriceService: TrainingPriceService,
        private languageHelper: JhiLanguageHelper,
        private trans: Transition
    ) {}

    ngOnInit(): void {
        this.trainingId = this.trans.params()['id'];

        if (TrainingComponent.languageStatic) {
            this.language = TrainingComponent.languageStatic;
        } else {
            this.language = this.languageHelper.getCurrentLang();
        }

        this.fetchTraining(this.trainingId, this.language);

        this.trainingService.getUniverses().subscribe((universes) => {
            this.universes = universes;
        });
        this.trainingService.getPartners().subscribe((partners) => {
            this.partners = partners;
        });
    }

    addNewCity() {
        this.trainingPriceService.addNewCity(this.training.trainingPrices);
    }

    removeCity(index: number) {
        this.trainingPriceService.removeCity(
            index,
            this.training.trainingPrices
        );
    }

    addNewUniverse() {
        this.training.trainingUniverses.push({ order: 0 });
    }

    removeUniverse(index: number) {
        this.training.trainingUniverses.splice(index, 1);
    }

    addNewStudentQuote() {
        this.training.studentQuotes.push({
            trainingId: this.training.id,
            date: new Date(),
            author: '',
            quote: '',
        });
    }

    removeStudentQuote(index: number) {
        this.training.studentQuotes.splice(index, 1);
    }

    switchLanguage(language: string): void {
        if (this.language === language) {
            return;
        }

        this.fetchTraining(this.trainingId, language);
    }

    fetchTraining(id, language) {
        this.trainingService
            .findById(id, true, language)
            .subscribe((training) => {
                this.language = language;
                this.training = training;
                this.training.studentQuotes = this.training.studentQuotes || [];
                this.updateTime();
                this.trainingPicturePath = training.picturePath;
                this.training.price /= 100;
                if (this.training.trainingPrices) {
                    this.training.trainingPrices =
                        this.trainingPriceService.formatTrainingPrices(
                            this.training.trainingPrices,
                            false
                        );
                }
                if (this.training.partnerFees) {
                    this.training.partnerFees = this.training.partnerFees / 100;
                }
            });
    }

    change(country: string, item: TrainingPrice): void {
        this.trainingPriceService.setCountry(country, item);
    }

    save(): void {
        const training = JSON.parse(JSON.stringify(this.training));
        training.price *= 100;
        training.language = this.language;

        training.trainingPrices = this.training.trainingPrices.filter(
            (trainingPrice) =>
                trainingPrice.country &&
                trainingPrice.city &&
                trainingPrice.price &&
                trainingPrice.currencyCode
        );

        if (training.trainingPrices) {
            training.trainingPrices =
                this.trainingPriceService.formatTrainingPrices(
                    this.training.trainingPrices,
                    true
                );
        }
        if (training.partnerFees) {
            training.partnerFees = !isNaN(training.partnerFees)
                ? training.partnerFees * 100
                : null;
        }
        this.trainingService.update(training).subscribe((response) => {
            if (response !== null) {
                this.success = true;
                this.trainingSaved.emit(training);

                if (training.trainingPrices) {
                    training.trainingPrices =
                        this.trainingPriceService.formatTrainingPrices(
                            this.training.trainingPrices,
                            false
                        );
                }

                window.setTimeout(() => {
                    window.scrollTo(0, document.body.scrollHeight);
                }, 0);
            }
        });
    }

    load(id: string) {
        this.trainingService.findById(id, true).subscribe((training) => {
            this.trainingId = id;
            this.pictureFileError = '';
            this.updateTime();
            this.trainingPicturePath = training.picturePath;
            this.training.picturePath = training.picturePath;
            this.getTraining.emit(this.trainingPicturePath);
        });
    }

    updateTime() {
        this.time = new Date().getTime() + '';
    }

    getBoolTranslateKey(data: any): string {
        if (data) {
            return 'global.true';
        }
        return 'global.false';
    }

    resetPicture($event) {
        $event.preventDefault();

        this.trainingService.resetPicture(this.training.id).subscribe(() => {
            this.load(this.trainingId);
        });
    }

    trainingPictureFileChange($event) {
        const files = $event.srcElement.files;
        this.pictureFileError = '';
        if (files.length === 1) {
            const file = files[0];
            if (file.size > 500000) {
                // 500 ko
                this.pictureFileError =
                    'Merci de selectionner une image de moins de 500 ko';
            } else {
                this.trainingService
                    .uploadPicture(this.training.id, file)
                    .subscribe(() => this.load(this.trainingId));
            }
        } else {
            this.pictureFileError = 'Merci de selectionner un fichier';
        }
    }

    trackByFn(index, item) {
        return index;
    }

    getUniverseName(universeId: number) {
        return this.universes.find((universe) => universe.id === universeId)
            .name;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/description/description.component.ts